export const Allowed_Route = {
  Mortgage_Application: 'Mortgage_Application',
  Application: 'Application',
  Mortgage_PostApp: 'Mortgage_Postapp',
  Consumer_PostApp: 'Consumer_PostApp',
  OAO_PostApp: 'OAO_PostApp'
};
